import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import {
  CmsProductCarouselComponent,
  CmsProductReferencesComponent,
  Product,
  ProductReferenceService
} from '@spartacus/core';
import {
  BREAKPOINT,
  BreakpointService,
  CmsComponentData,
  CurrentProductService,
  ProductReferencesComponent
} from '@spartacus/storefront';
import { Observable, Subscription, of } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-custom-product-references',
  templateUrl: './custom-product-references.component.html',
  styleUrls: ['./custom-product-references.component.scss'],
  standalone: false
})
export class CustomProductReferencesComponent extends ProductReferencesComponent implements OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  animation = 'swipe';
  approvedItems$: Observable<Observable<Product>[]> = new Observable();
  component$: Observable<CmsProductCarouselComponent> = this.cmsComponentData.data$.pipe(
    filter(Boolean),
  );

  constructor(
    protected cmsComponentData: CmsComponentData<CmsProductReferencesComponent>,
    protected currentProductService: CurrentProductService,
    protected productReferenceService: ProductReferenceService,
    protected breakpointService: BreakpointService,
    protected cd: ChangeDetectorRef,
  ) {
    super(cmsComponentData,
      currentProductService,
      productReferenceService,
    );

    this.subscriptions.add(this.items$.subscribe((items: Observable<Product>[]) => {
      if (items) {
        let productList: Observable<Product>[] = [];
        items.map((item: Observable<Product>) =>
          this.subscriptions.add(item.subscribe((product: Product) => {
            if (product) {
              productList = [...productList, of(product)];
              this.approvedItems$ = of(productList);
              this.cd.markForCheck();
            }
          })),
        );
      }
    }));
  }

  isMobile(): Observable<boolean> {
    return this.breakpointService?.isDown(BREAKPOINT.sm);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
